export default __webpack_public_path__ + "static/media/880a0987dfaa6c22141d72e92dbd94571581611979075.3c8ff8fd.webp";